/** Code-native point symbols, drawn at twice their displayed resolution. */
export function miscSymbolImage(kind: "pass" | "ais" | "landing-t" | "windsock"): ImageData {
  const canvas = document.createElement("canvas");
  canvas.width = canvas.height = 64;
  const ctx = canvas.getContext("2d")!;
  if (kind === "ais") {
    ctx.fillStyle = "#ffff00";
    ctx.fillRect(3, 3, 58, 58);
    ctx.strokeStyle = "#000";
    ctx.lineWidth = 2;
    ctx.strokeRect(3, 3, 58, 58);
    ctx.fillStyle = "#000";
    ctx.font = "bold 49px Arial";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText("C", 32, 34);
  } else if (kind === "landing-t") {
    ctx.fillStyle = "#fff";
    ctx.fillRect(3, 3, 58, 58);
    ctx.strokeStyle = "#000";
    ctx.lineWidth = 2;
    ctx.strokeRect(3, 3, 58, 58);
    ctx.fillStyle = "#000";
    ctx.fillRect(12, 13, 40, 8);
    ctx.fillRect(28, 13, 8, 40);
  } else if (kind === "windsock") {
    ctx.strokeStyle = "#000";
    ctx.lineWidth = 3;
    ctx.beginPath();
    ctx.moveTo(12, 10);
    ctx.lineTo(12, 59);
    ctx.stroke();
    const top = (x: number) => 12 + (x - 14) * 0.18;
    const bottom = (x: number) => 34 - (x - 14) * 0.12;
    for (let i = 0; i < 5; i++) {
      const a = 14 + i * 9,
        b = a + 9;
      ctx.fillStyle = i % 2 === 0 ? "#e02020" : "#fff";
      ctx.beginPath();
      ctx.moveTo(a, top(a));
      ctx.lineTo(b, top(b));
      ctx.lineTo(b, bottom(b));
      ctx.lineTo(a, bottom(a));
      ctx.closePath();
      ctx.fill();
    }
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(14, top(14));
    ctx.lineTo(59, top(59));
    ctx.lineTo(59, bottom(59));
    ctx.lineTo(14, bottom(14));
    ctx.closePath();
    ctx.stroke();
    ctx.beginPath();
    ctx.ellipse(14, 23, 4, 11, 0, 0, Math.PI * 2);
    ctx.stroke();
  } else {
    ctx.strokeStyle = "#000";
    ctx.lineWidth = 7;
    ctx.lineJoin = "miter";
    for (const side of [1, -1]) {
      ctx.beginPath();
      ctx.moveTo(32 + side * 27, 6);
      ctx.lineTo(32 + side * 13, 20);
      ctx.lineTo(32 + side * 13, 44);
      ctx.lineTo(32 + side * 27, 58);
      ctx.stroke();
    }
  }
  return ctx.getImageData(0, 0, 64, 64);
}
